import { MatchStatus, ScheduledMatch, TeamData, TeamModel } from 'types/Schedule.types';

export const createInitialScheduledMatch = (
  homeTeam: TeamModel,
  awayTeam: TeamModel,
  startingDate: string
): ScheduledMatch => {
  return {
    homeTeamId: homeTeam.teamID,
    homeTeamAbv: homeTeam.teamAbv,
    homeTeamPoints: 0,
    awayTeamId: awayTeam.teamID,
    awayTeamAbv: awayTeam.teamAbv,
    awayTeamPoints: 0,
    timeRemaining: 60,
    matchId: '',
    startingDate: new Date(startingDate).toISOString(),
    matchStatus: MatchStatus.Scheduled,
  };
};

export const convertToScheduledMatch = (
  matchId: string,
  homeTeam: TeamModel,
  awayTeam: TeamModel,
  startingDate: string
): ScheduledMatch => {
  return {
    homeTeamId: homeTeam.teamID,
    homeTeamAbv: homeTeam.teamAbv,
    homeTeamPoints: 0,
    awayTeamId: awayTeam.teamID,
    awayTeamAbv: awayTeam.teamAbv,
    awayTeamPoints: 0,
    timeRemaining: 60,
    matchId: matchId,
    startingDate: new Date(startingDate).toISOString(),
    matchStatus: MatchStatus.Scheduled,
  };
};

export const getTeamDataModel = (team: TeamModel): TeamData => {
  return {
    team,
    pointsAllowed: 0,
    pointsFor: 0,
    scoring: [],
  };
};
